"use client";
import React, { useId, useEffect } from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

import classNames from "classnames";

import { useSelector } from "react-redux";

import { getToken } from "helpers/auth";
import { favoriteHelpers } from "@/src/helpers/favorite";

import ListingCard from "components/cards/listing-card";
import ProjectCard from "components/cards/project-card";
import SaveSearchCard from "components/cards/save-search-card";
import HousingProjectsCard from "components/cards/housing-projects-card";
// import GptAd from "components/gpt-ad-element";
import RegionPrice from "components/listing-search/region-price";

import styles from "./styles.module.css";

const GptAd = dynamic(() => import("components/gpt-ad-element"), { ssr: false });

const StickyFavoriteInfoBar = dynamic(() => import("components/common/sticky-favorite-info-bar"), { ssr: false });

const Content = ({ listingItems, projectListing, pageType, name, urlPath, criteria, similarCount, isLandingPage }) => {
  const id = useId();

  const getAllFavoritesByAccount = favoriteHelpers();

  const favoriteInfoBarButtonContent = useSelector((state) => state.favorite.favoriteInfoBarButtonContent);
  const favoriteInfoListingId = useSelector((state) => state.listingSearch.handleListingIdClickFavorite);

  const projectLocation = [5, 11, 17, 23, 29];
  const mergeList = [];
  let counter = 0;
  listingItems?.forEach((item, index) => {
    mergeList.push(item);

    if (projectLocation.includes(index) && projectListing?.length > counter) {
      mergeList.push(projectListing[counter]);
      counter += 1;
    }
  });

  const isForSaleHousing = () => {
    const categorySlug = criteria?.category?.category?.slug ?? "";
    const tradeTypeSlug = criteria?.category?.tradeType?.slug ?? "";
    const isHousingForSale = categorySlug === "konut" && tradeTypeSlug === "satilik" && projectListing?.length > 0;
    return isHousingForSale;
  };

  const housingProjectClass = classNames({
    [styles.housingProjectWrapper]: isForSaleHousing(),
  });

  const handleInfoBarSuccessCallback = async () => {
    await getAllFavoritesByAccount();
  };

  useEffect(() => {
    if (getToken()) getAllFavoritesByAccount();
  }, []);

  const isOOPAdVisible = pageType === "listing" || pageType === "project";

  return (
    <div className={styles.wrapper}>
      {isOOPAdVisible && <GptAd key="ej_w_oop" style={{ height: "0px" }} elementId="div-gpt-ad-1629981973945-0" />}
      {listingItems &&
        mergeList &&
        pageType === "listing" &&
        mergeList?.map((listingItem, index) => (
          <div className={styles.listingWrapper} key={`${id}-${index}`}>
            {index === 3 && isForSaleHousing() && (
              <div className={housingProjectClass}>
                <HousingProjectsCard criteria={criteria} />
              </div>
            )}
            {((isForSaleHousing() && index === 17) || (!isForSaleHousing() && index === 3)) && (
              <div className={styles.saveSeasrchWrapper}>
                <SaveSearchCard name={name} urlPath={urlPath} />
              </div>
            )}
            {index === 5 && !isLandingPage && <RegionPrice />}
            {index === 6 ? (
              <div className={styles.adSlotWrap}>
                <GptAd key={`${id}__${index}`} elementId="div-gpt-ad-1568114437700-0" />
              </div>
            ) : index === 10 ? (
              <div className={styles.adSlotWrap}>
                <GptAd key={`${id}__${index}`} elementId="div-gpt-ad-1568114516687-0" />
              </div>
            ) : index === 17 ? (
              <div className={styles.adSlotWrap}>
                <GptAd key={`${id}__${index}`} elementId="div-gpt-ad-1720011550847-0" />
              </div>
            ) : index === 24 ? (
              <div className={styles.adSlotWrap}>
                <GptAd key={`${id}__${index}`} elementId="div-gpt-ad-1720011428178-0" />
              </div>
            ) : null}

            {listingItem?.tags ? (
              <ProjectCard
                title={listingItem?.name}
                companyName={listingItem?.companyName}
                cityName={listingItem?.locationInfo.cityName}
                districtName={listingItem?.locationInfo.districtName}
                area={listingItem?.area}
                flatCount={listingItem?.flatCount}
                deliveryDate={listingItem?.deliveryDate}
                isImmediateDelivery={listingItem?.isImmediateDelivery}
                priceVisibility={listingItem?.price?.priceVisibility}
                priceSummary={listingItem?.price?.priceSummary}
                coverPhoto={listingItem?.images[0]}
                projectBadgeCard={true}
                campaigns={listingItem?.campaigns}
                isPremium={listingItem?.premium}
                salesStatus={listingItem?.salesStatus}
                url={listingItem?.url}
                id={listingItem?.id}
                index={index}
              />
            ) : (
              <ListingCard
                badges={listingItem?.badges}
                videoUrl={listingItem?.videoUrl}
                virtualTourUrl={listingItem?.virtualTourUrl}
                title={listingItem?.title}
                locationSummary={listingItem?.locationSummary || listingItem?.location?.summary}
                categoryTypeName={listingItem?.categoryTypeName}
                estateTypeName={listingItem?.estateTypeName}
                quickInfos={listingItem?.quickInfos}
                squareMeter={listingItem?.squareMeter}
                price={listingItem?.priceDetail?.price}
                currency={listingItem?.priceDetail?.currency}
                previousPrice={
                  listingItem?.priceDetail?.trendType === "down" ? listingItem?.priceDetail?.previousPrice : null
                }
                previousCurrency={listingItem?.priceDetail?.previousCurrency}
                landFeatures={listingItem?.landSubStructuralFeatures}
                phoneNumber={listingItem?.phoneNumber}
                alternateBank={listingItem?.listingLogo}
                coverPhoto={listingItem?.images[0]}
                url={listingItem?.url}
                alternativeValue={listingItem?.priceDetail?.alternativeValue}
                id={listingItem?.id}
                listingItem={listingItem}
                isPlatinum={listingItem?.badges?.includes("platinum")}
                index={index}
                similarCount={similarCount}
                listings={mergeList}
              />
            )}
          </div>
        ))}
      {projectListing &&
        pageType === "project" &&
        projectListing?.map((projectItem, index) => (
          <div className={styles.listingWrapper} key={`${id}-${index}`}>
            <ProjectCard
              title={projectItem.name}
              companyName={projectItem.companyName}
              cityName={projectItem.locationInfo.cityName}
              districtName={projectItem.locationInfo.districtName}
              area={projectItem.area}
              flatCount={projectItem.flatCount}
              deliveryDate={projectItem.deliveryDate}
              isImmediateDelivery={projectItem.isImmediateDelivery}
              priceVisibility={projectItem.price?.priceVisibility}
              priceSummary={projectItem.price?.priceSummary}
              coverPhoto={projectItem.listingPhoto}
              campaigns={projectItem.campaigns}
              isPremium={projectItem.premium}
              salesStatus={projectItem.salesStatus}
              url={projectItem?.url}
              id={projectItem?.id}
              index={index}
            />
          </div>
        ))}
      <StickyFavoriteInfoBar
        listingId={favoriteInfoListingId}
        successCallback={handleInfoBarSuccessCallback}
        backButtonCondition={favoriteInfoBarButtonContent === "Geri Al"}
      />
    </div>
  );
};

Content.propTypes = {
  listingItems: PropTypes.array,
  pageType: PropTypes.string,
  criteria: PropTypes.object,
  projectListing: PropTypes.array,
  name: PropTypes.string,
  urlPath: PropTypes.string,
  similarCount: PropTypes.number,
  isLandingPage: PropTypes.bool,
};

export default Content;
